export const EXTERNAL_DATA_TYPE_PREFIX = 'EXT_';
export const isExternalDataType = dataType => !!dataType && dataType.startsWith(EXTERNAL_DATA_TYPE_PREFIX);